import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';

const HISTORY_FRAGMENT = gql(`
  fragment sumHistoryStats_history on SlimHistory {
    id
    stats {
      insert
      delete
      comment
      resolve
    }
  }
`);

const sumHistoryStats = (
  histories: DocumentType<typeof HISTORY_FRAGMENT>[],
) => {
  return histories.reduce(
    (acc, history) => {
      return {
        insert: acc.insert + history.stats.insert,
        delete: acc.delete + history.stats.delete,
        comment: acc.comment + history.stats.comment,
        resolve: acc.resolve + history.stats.resolve,
      };
    },
    { insert: 0, delete: 0, comment: 0, resolve: 0 },
  );
};

export default sumHistoryStats;
